
import "./fontawsome.css";
import "./App.css";
import RootComponent from "./routers/root-component";
import { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";


import SocketIO from "./socketIO";

if (!globalThis.socketIO) {
  globalThis.socketIO = SocketIO();
}

function App() {
  const getFlag = (short: string) => {
    const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
    // for dumi
    if (typeof data === "string") {
      return data;
    }
    // for CRA
    return data.default;
  };
  return (
    <ConfigProvider
      locale={en}
      areaMapper={(area) => {
        return {
          ...area,
          emoji: (
            <img
              alt="flag"
              style={{ width: 20, height: 20, verticalAlign: "sub" }}
              src={getFlag(area.short)}
            />
          )
        };
      }}
    >
      <RootComponent />
    </ConfigProvider>
  );
}

export default App;
